import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'dateNoOffset'
})
export class DateNoOffsetPipe implements PipeTransform {

  transform(value: any, format?: string): any {
    if (value == null || value === '') {
      return '';
    }

    try {
      // Parse the date string without timezone conversion
      let dateValue: Date;
      
      if (typeof value === 'string') {
        // Handle ISO string with timezone (e.g., "2026-01-06T00:00:00-08:00")
        // Extract just the date and time parts without timezone
        const isoMatch = value.match(/^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2})/);
        if (isoMatch) {
          // Use the date/time part without timezone to avoid conversion
          dateValue = new Date(isoMatch[1]);
        } else {
          // Fallback: remove timezone info if present
          const cleanDateString = value.replace(/[+-]\d{2}:\d{2}$|Z$/, '');
          dateValue = new Date(cleanDateString);
        }
      } else if (value instanceof Date) {
        dateValue = value;
      } else {
        dateValue = new Date(value);
      }

      // Check if date is valid
      if (isNaN(dateValue.getTime())) {
        console.warn('Invalid date value:', value);
        return '';
      }

      // Use the provided format or default to environment format
      const dateFormat = format || environment.formatDate || 'dd/MM/yyyy';
      
      // Format the date manually to avoid timezone conversion
      return this.formatDateManually(dateValue, dateFormat);
      
    } catch (error) {
      console.warn('Error formatting date:', error);
      return '';
    }
  }

  private formatDateManually(date: Date, format: string): string {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    // Replace format tokens with actual values
    return format
      .replace(/dd/g, day)
      .replace(/MM/g, month)
      .replace(/yyyy/g, year)
      .replace(/HH/g, hours)
      .replace(/mm/g, minutes)
      .replace(/ss/g, seconds);
  }
}

@Pipe({
  name: 'dateTimeNoOffset'
})
export class DateTimeNoOffsetPipe implements PipeTransform {

  transform(value: any, format?: string): any {
    if (value == null || value === '') {
      return '';
    }

    try {
      // Parse the date string without timezone conversion
      let dateValue: Date;
      
      if (typeof value === 'string') {
        // Handle ISO string with timezone (e.g., "2026-01-06T00:00:00-08:00")
        // Extract just the date and time parts without timezone
        const isoMatch = value.match(/^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2})/);
        if (isoMatch) {
          // Use the date/time part without timezone to avoid conversion
          dateValue = new Date(isoMatch[1]);
        } else {
          // Fallback: remove timezone info if present
          const cleanDateString = value.replace(/[+-]\d{2}:\d{2}$|Z$/, '');
          dateValue = new Date(cleanDateString);
        }
      } else if (value instanceof Date) {
        dateValue = value;
      } else {
        dateValue = new Date(value);
      }

      // Check if date is valid
      if (isNaN(dateValue.getTime())) {
        console.warn('Invalid date value:', value);
        return '';
      }

      // Use the provided format or default to environment format
      const dateTimeFormat = format || environment.formatDateTime || 'dd/MM/yyyy HH:mm';
      
      // Format the date manually to avoid timezone conversion
      return this.formatDateManually(dateValue, dateTimeFormat);
      
    } catch (error) {
      console.warn('Error formatting date time:', error);
      return '';
    }
  }

  private formatDateManually(date: Date, format: string): string {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    // Replace format tokens with actual values
    return format
      .replace(/dd/g, day)
      .replace(/MM/g, month)
      .replace(/yyyy/g, year)
      .replace(/HH/g, hours)
      .replace(/mm/g, minutes)
      .replace(/ss/g, seconds);
  }
}
